import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ConfigurationStoryblok } from '../../../_shared/interfaces/storyblok';

function SEO({
    metadata,
    config,
    full_slug,
}: {
    metadata: {
        _uid?: string;
        title?: string;
        plugin?: string;
        og_image?: string;
        og_title?: string;
        description?: string;
        twitter_image?: string;
        twitter_title?: string;
        og_description?: string;
        twitter_description?: string;
        [k: string]: any;
    };
    config: ConfigurationStoryblok;
    full_slug: string;
}) {
    return (
        <Helmet
            htmlAttributes={{
                lang: config.language,
            }}
            bodyAttributes={{
                class: `theme-${config.theme}`,
            }}
            title={metadata.title}
            titleTemplate={`%s ${config.title ? `| ${config.title}` : ``}`}
            meta={[
                {
                    name: `description`,
                    content: metadata.description,
                },
                {
                    property: `og:title`,
                    content: metadata.og_title ? `${metadata.og_title}` : `${config.title} - ${metadata.title}`,
                },
                {
                    property: `og:description`,
                    content: metadata.og_description ? `${metadata.og_description}` : `${metadata.description}`,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `og:image`,
                    content: metadata.og_image,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: config.author,
                },
                {
                    name: `twitter:title`,
                    content: metadata.twitter_title ? `${metadata.twitter_title}` : `${config.title} - ${metadata.title}`,
                },
                {
                    name: `twitter:description`,
                    content: metadata.twitter_description ? `${metadata.twitter_description}` : `${metadata.description}`,
                },
                {
                    name: `twitter:image`,
                    content: metadata.twitter_image,
                },
            ]}
            link={[
                {
                    rel: 'canonical',
                    href: `${process.env.GATSBY_SITE_URL}/${full_slug}${full_slug[full_slug.length - 1] === '/' ? '' : '/'}`,
                },
            ]}
        />
    );
}

export default SEO;
